/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
/** @packageDocumentation
 * @module Utilities
 */

/** Describes 2d dimensions.
 * @public
 * @deprecated in 4.16.0. Use {@link @itwin/appui-react#SizeProps} instead.
 */
export interface SizeProps {
  readonly width: number;
  readonly height: number;
}
